import { ReactNode } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import 'dayjs/locale/en';
import 'dayjs/locale/vi';
import 'dayjs/locale/da';
import 'dayjs/locale/sv';
import 'dayjs/locale/nb';

import { useLocalization } from '../../../localization';

interface Props {
  children: ReactNode;
}

const dayjsLocaleMap = {
  en: 'en',
  da: 'da',
  sv: 'sv',
  no: 'nb',
};

const DateLocalizationProvider = ({ children }: Props) => {
  const { locale } = useLocalization();

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale={dayjsLocaleMap[locale as keyof typeof dayjsLocaleMap] || 'en'}
    >
      {children}
    </LocalizationProvider>
  );
};

export default DateLocalizationProvider;
